/**
 * NFL Sport Configuration
 *
 * Positions, prop categories, roster slots, teams, and brand identity
 * for the NFL sport within FantasyPRIME.
 */

import type { SportConfig } from './types';

export const nflConfig: SportConfig = {
  sport: 'NFL',
  label: 'NFL Football',
  shortLabel: 'NFL',

  oddsApiSportKey: 'americanfootball_nfl',

  drawLabel: 'Tie',
  espnPath: { sport: 'football', league: 'nfl' },

  positions: [
    { id: 'QB', label: 'Quarterback', abbreviation: 'QB' },
    { id: 'RB', label: 'Running Back', abbreviation: 'RB' },
    { id: 'WR', label: 'Wide Receiver', abbreviation: 'WR' },
    { id: 'TE', label: 'Tight End', abbreviation: 'TE' },
    { id: 'K', label: 'Kicker', abbreviation: 'K' },
  ],

  propCategories: [
    { id: 'PASSING_YARDS', label: 'Passing Yards', oddsApiMarket: 'player_pass_yds' },
    { id: 'PASSING_TDS', label: 'Passing TDs', oddsApiMarket: 'player_pass_tds' },
    { id: 'PASS_COMPLETIONS', label: 'Completions', oddsApiMarket: 'player_pass_completions' },
    { id: 'PASS_INTERCEPTIONS', label: 'Interceptions Thrown', oddsApiMarket: 'player_pass_interceptions' },
    { id: 'RUSHING_YARDS', label: 'Rushing Yards', oddsApiMarket: 'player_rush_yds' },
    { id: 'RUSH_ATTEMPTS', label: 'Rush Attempts', oddsApiMarket: 'player_rush_attempts' },
    { id: 'RECEIVING_YARDS', label: 'Receiving Yards', oddsApiMarket: 'player_reception_yds' },
    { id: 'RECEPTIONS', label: 'Receptions', oddsApiMarket: 'player_receptions' },
    { id: 'RUSH_RECEIVING_YARDS', label: 'Rush + Rec Yards', oddsApiMarket: 'player_rush_reception_yds' },
    { id: 'ANYTIME_TD', label: 'Anytime TD', oddsApiMarket: 'player_anytime_td' },
    { id: 'KICKING_POINTS', label: 'Kicking Points', oddsApiMarket: 'player_kicking_points' },
    { id: 'SACKS', label: 'Sacks', oddsApiMarket: 'player_sacks' },
  ],

  defaultRosterSlots: [
    { slot: 'QB', eligiblePositions: ['QB'], label: 'Quarterback' },
    { slot: 'RB1', eligiblePositions: ['RB'], label: 'Running Back' },
    { slot: 'RB2', eligiblePositions: ['RB'], label: 'Running Back' },
    { slot: 'WR1', eligiblePositions: ['WR'], label: 'Wide Receiver' },
    { slot: 'WR2', eligiblePositions: ['WR'], label: 'Wide Receiver' },
    { slot: 'TE', eligiblePositions: ['TE'], label: 'Tight End' },
    { slot: 'FLEX', eligiblePositions: ['RB', 'WR', 'TE'], label: 'Flex' },
    { slot: 'K', eligiblePositions: ['K'], label: 'Kicker' },
  ],

  defaultRosterSize: 8,
  defaultMaxProps: 5,

  identity: {
    color: '#9B111E',
    metal: 'Ruby',
    icon: 'Shield',
  },

  teams: {
    ARI: 'Arizona Cardinals',
    ATL: 'Atlanta Falcons',
    BAL: 'Baltimore Ravens',
    BUF: 'Buffalo Bills',
    CAR: 'Carolina Panthers',
    CHI: 'Chicago Bears',
    CIN: 'Cincinnati Bengals',
    CLE: 'Cleveland Browns',
    DAL: 'Dallas Cowboys',
    DEN: 'Denver Broncos',
    DET: 'Detroit Lions',
    GB: 'Green Bay Packers',
    HOU: 'Houston Texans',
    IND: 'Indianapolis Colts',
    JAX: 'Jacksonville Jaguars',
    KC: 'Kansas City Chiefs',
    LAC: 'Los Angeles Chargers',
    LAR: 'Los Angeles Rams',
    LV: 'Las Vegas Raiders',
    MIA: 'Miami Dolphins',
    MIN: 'Minnesota Vikings',
    NE: 'New England Patriots',
    NO: 'New Orleans Saints',
    NYG: 'New York Giants',
    NYJ: 'New York Jets',
    PHI: 'Philadelphia Eagles',
    PIT: 'Pittsburgh Steelers',
    SEA: 'Seattle Seahawks',
    SF: 'San Francisco 49ers',
    TB: 'Tampa Bay Buccaneers',
    TEN: 'Tennessee Titans',
    WAS: 'Washington Commanders',
  },
};
